const envPublicUrl =
  import.meta.env.VITE_PUBLIC_URL && import.meta.env.VITE_PUBLIC_URL !== '/'
    ? import.meta.env.VITE_PUBLIC_URL
    : '';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // baseUrl: 'http://fsp4.dev.fasoo.com:17000',
  contextPath: envPublicUrl ? envPublicUrl : '/',
  url: (subUrl: string): string => `${envPublicUrl}${subUrl}`,
  servers: {
    gateway: {
      enabled: true,
      url: '/gateway',
    },
    policy: {
      enabled: false,
      url: 'http://policy-service/policy',
    },
    fsp: {
      enabled: false,
      // url: 'http://fsp-service/fsp',
      url: '/gateway/fsp',
    },
    infra: {
      enabled: true,
      // url: 'http://infra-service/infra',
      url: '/gateway/infra',
    },
    fidp: {
      enabled: true,
      url: '/gateway/fidp',
    },
    log: {
      enabled: false,
      version: '1.1',
      periodDays: 14,
      url: '/gateway/flas/v1/query',
      urlDownload: '/gateway/flas/v1/export',
    },
    auth: {
      enabled: true,
      url: '/gateway/auth',
    },
    pki: {
      enabled: false,
      url: '/gateway/pki',
    },
    fxm: {
      enabled: true,
      url: '/gateway/fxm',
    },
    issuance: {
      enabled: true,
      url: '/gateway/issuance',
    },
    config: {
      enabled: true,
      url: '/gateway/configuration',
    },
    fdrledger: {
      enabled: true,
      url: '/gateway/fdrledger',
    },
  },
};
